var _ = require('underscore');
var Marionette = require('marionette');
var Dialog = require('Dialog');
var Labels = EY.Consultation.Labels;
var Validation = require('validation');

var View = Marionette.View.extend({
    events: {
        'blur @ui.text': 'update'
    },
    template: '#dialogSavedFilters',
    ui: {
        text: '#text'
    },
    initialize: function () {
        Validation.bind(this);
    },
    update: function () {
        var text = this.ui.text.val().trim();

this.model.set({ id: text, text: _.escape(text) });
    }
});

module.exports.show = function (options) {
    var model = options.model;

    return Dialog.show({
        headerLabel: Labels.SaveFilters,
        saveLabel: Labels.Close,
        view: new View({
            model: model
        })
    });
};


// WEBPACK FOOTER //
// ./js/Modules/Dialog/DialogFilterSave.js